import moment from "moment";
import "moment/locale/es";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

// Función auxiliar para obtener el texto del estado
const getEstadoTexto = (estadoNum) => {
  switch (estadoNum) {
    case 1:
      return "Pendiente";
    case 2:
      return "En Proceso";
    case 3:
      return "Terminada";
    case 0:
      return "Cancelada";
    default:
      return "Desconocido";
  }
};

const reporteRequisicionesPdf = (values) => {
  const empresa = values.empresa;
  const logoBiwo = values.logoBiwo;
  let filtrados = [];


  if (values.proveedores && values.proveedores.length > 0) {
    let textoFiltrado = "";
    values.proveedores.map((valueProveedor) => {
      textoFiltrado += `${valueProveedor.stringBuscar || (valueProveedor.razonSocial + " - " + valueProveedor.rfc)}\n`;
      return null;
    });
    filtrados.push([
      { text: "Proveedores:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }


  if (values.solicitantes && values.solicitantes.length > 0) {
    let textoFiltrado = "";
    values.solicitantes.map((valueUsuario) => {
      textoFiltrado += `${valueUsuario.nombre} ${valueUsuario.apellidoPaterno} ${valueUsuario.apellidoMaterno}\n`;
      return null;
    });
    filtrados.push([
      { text: "Solicitantes:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }


  if (values.proyectos && values.proyectos.length > 0) {
    let textoFiltrado = "";
    values.proyectos.map((valueProyecto) => {
      textoFiltrado += `${valueProyecto.nombre}\n`;
      return null;
    });
    filtrados.push([
      { text: "Proyectos:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }


  if (values.estadoRequisicion !== 5) {
    filtrados.push([
      { text: "Estado:", style: "subheader" },
      { text: getEstadoTexto(values.estadoRequisicion), style: "textoChico" },
    ]);
  }


  if (filtrados.length === 0) {
    filtrados.push([
      { text: "No tiene filtrados adicionales", style: "subheader" },
      { text: "", style: "textoChico" },
    ]);
  }

  let requisiciones = [];
  const desglosar = values.desglosarProductos;
  
  let tableHeaders = [];
  let tableWidths = [];

  if (desglosar) {

    tableHeaders = [
      { text: "Folio/Código", style: "tituloTabla" },
      { text: "Insumo/Fecha", style: "tituloTabla" },
      { text: "Familia", style: "tituloTabla" },
      { text: "Proveedor", style: "tituloTabla" },
      { text: "Solicitante", style: "tituloTabla" },
      { text: "Proyecto", style: "tituloTabla" },
      { text: "Cant. Sol.", style: "tituloTabla" },
      { text: "Cant. Ord.", style: "tituloTabla" },
      { text: "Estado", style: "tituloTabla" },
    ];
    tableWidths = ["8%", "20%", "12%", "12%", "13%", "13%", "6%", "8%", "8%"];

    for (const req of values.requisiciones) {
      if (req.esInsumo) {
        requisiciones.push([
          { text: req.codigo || "N/A", style: "textoTabla", alignment: "left" },
          { text: req.descripcion || "N/A", style: "textoTabla", alignment: "left" },
          { text: req.familia || "N/A", style: "textoTabla", alignment: "left" },
          { text: req.proveedor || "N/A", style: "textoTabla", alignment: "left" },
          { text: "", style: "textoTabla" },
          { text: "", style: "textoTabla" },
          { text: req.cantidadSolicitada, style: "textoTabla", alignment: "right" },
          { text: req.cantidadOrdenada, style: "textoTabla", alignment: "right" },
          { text: getEstadoTexto(req.estado), style: "textoTabla", alignment: "left" },
        ]);
      } else {
        requisiciones.push([
          { text: req.folio, style: "textoTabla", bold: true, alignment: "left" },
          { text: req.fecha, style: "textoTabla", bold: true, alignment: "left" }, // Usamos la columna de insumo para la fecha
          { text: "", style: "textoTabla" }, // Columna Familia vacía
          { text: "", style: "textoTabla" }, // Columna Proveedor vacía
          { text: req.solicitante, style: "textoTabla", bold: true, alignment: "left" },
          { text: req.proyecto, style: "textoTabla", bold: true, alignment: "left" },
          { text: req.cantidadSolicitada, style: "textoTabla", bold: true, alignment: "right" },
          { text: req.cantidadOrdenada, style: "textoTabla", bold: true, alignment: "right" },
          { text: getEstadoTexto(req.estado), style: "textoTabla", bold: true, alignment: "left" },
        ]);
      }
    }
  } else {
    tableHeaders = [
      { text: "Folio", style: "tituloTabla" },
      { text: "Fecha", style: "tituloTabla" },
      { text: "Solicitante", style: "tituloTabla" },
      { text: "Proyecto", style: "tituloTabla" },
      { text: "Cant. Sol.", style: "tituloTabla" },
      { text: "Cant. Ord.", style: "tituloTabla" },
      { text: "Estado", style: "tituloTabla" },
    ];
    tableWidths = ["12%", "12%", "25%", "25%", "7%", "10%", "9%"];

    for (const req of values.requisiciones) {
      requisiciones.push([
        { text: req.folio, style: "textoTabla", alignment: "left" },
        { text: req.fecha, style: "textoTabla", alignment: "center" },
        { text: req.solicitante, style: "textoTabla", alignment: "left" },
        { text: req.proyecto, style: "textoTabla", alignment: "left" },
        { text: req.cantidadSolicitada, style: "textoTabla", alignment: "right" },
        { text: req.cantidadOrdenada, style: "textoTabla", alignment: "right" },
        { text: getEstadoTexto(req.estado), style: "textoTabla", alignment: "left" },
      ]);
    }
  }

  const totalSolicitado = values.totalInsumosSolicitados || 0;
  const totalOrdenado = values.totalInsumosOrdenados || 0;
  
  let totalsRow = [];

  if (desglosar) {
    totalsRow = [
      { text: "TOTAL:", style: "tituloTabla", alignment: "left", border: [true, true, true, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: totalSolicitado, style: "textoTotal", bold: true, alignment: "right", border: [true, true, true, true], fillColor: "#cccccc" },
      { text: totalOrdenado, style: "textoTotal", bold: true, alignment: "right", border: [true, true, true, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, true, true], fillColor: "#cccccc" },
    ];
  } else {
     totalsRow = [
      { text: "TOTAL:", style: "tituloTabla", alignment: "left", border: [true, true, true, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: totalSolicitado, style: "textoTotal", bold: true, alignment: "right", border: [true, true, true, true], fillColor: "#cccccc" },
      { text: totalOrdenado, style: "textoTotal", bold: true, alignment: "right", border: [true, true, true, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, true, true], fillColor: "#cccccc" },
    ];
  }

  requisiciones.push(totalsRow);


  // --- Definición del Documento PDF ---
  var dd = {
    footer: {
      image: "logoBiwo",
      alignment: "center",
      width: 80,
    },
    content: [
      // Cabecera (Logo, Info Empresa, Título Reporte, Fechas)
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              ...HeaderEmpresaCard(empresa, false,false,
              {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],
                  body: [
                    [{ text: "Fecha Inicial:", style: "subheader", alignment: "center" }],
                    [{ text: moment(values.fechaInicial).locale("es").format("LL"), style: "textoChico", alignment: "center" }],
                    [{ text: "Fecha Final:", style: "subheader", alignment: "center" }],
                    [{ text: moment(values.fechaFinal).locale("es").format("LL"), style: "textoChico", alignment: "center" }],
                    [{ text: "Fecha de Impresión:", style: "subheader", alignment: "center" }],
                    [{ text: moment().locale("es").format("LL"), style: "textoChico", alignment: "center" }],
                  ],
                },
                layout: "noBorders",
              }),
            ],
          ],
        },
      },
      {
        text:
        "Reporte de Requisiciones",
        style: "tableHeaderIzquierda",
      },
      // Tabla de Filtros
      { text: "Datos de filtrado:" },
      {
        style: "tableExample",
        table: {
          widths: ["20%", "80%"],
          body: filtrados, 
        },
        layout: {
          hLineWidth: function (i, node) { return 1; },
          vLineWidth: function (i, node) { return 1; },
          hLineColor: function (i, node) { return "#adaaaa"; },
          vLineColor: function (i, node) { return "#adaaaa"; },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) { return null; }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) { return null; }
            return { dash: { length: 2 } };
          },
        },
      },
      // Tabla Principal de Datos
      {
        style: "tableExample",
        table: {
          widths: tableWidths, 
          layout: {
            defaultBorder: true,
          },
          body: [
            tableHeaders,
            ...requisiciones, 
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            if (rowIndex === node.table.body.length - 1) {
              return "#cccccc";
            }
            if (rowIndex === 0) {
              return "#cccccc";
            }
            return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
          },
          hLineWidth: function (i, node) { return 1; },
          vLineWidth: function (i, node) { return 1; },
          hLineColor: function (i, node) { return "#adaaaa"; },
          vLineColor: function (i, node) { return "#adaaaa"; },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) { return null; }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) { return null; }
            return { dash: { length: 2 } };
          },
        },
      },
    ],
    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },
    styles: {
      tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
      header: {
        fontSize: 9,
        bold: true,
      },
      subheader: {
        fontSize: 8,
        bold: true,
      },
      tableExample: {
        margin: [0, 5, 0, 5],
      },
      tablaSinMargen: {
        margin: [0, 0, 0, 0],
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: "black",
        alignment: "center",
      },
      textoChico: {
        fontSize: 8,
      },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        style: "subheader",
        alignment: "center",
        border: true,
      },
      textoTabla: {
        fontSize: 8,
        italics: false,
      },
      textoTotal: {
        fontSize: 8, 
        bold: true,
        italics: false,
      },
    },
    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 60],
  };
  return dd;
};

export default reporteRequisicionesPdf;